import { ModalAlertaComponent } from './modal-alerta/modal-alerta.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Injectable } from '@angular/core';

export enum TipoAlerta {
  PERIGO = 'danger',
  SUCESSO = 'success',
  AVISO = 'warning',
  INFO = 'info'
}

@Injectable({
  providedIn: 'root'
})
export class ModalAlertaService {
  constructor(private modalService: BsModalService) {}

  private mostrarAlerta(mensagem: string, tipo: TipoAlerta, detalhes: any) {
    const bsModalRef: BsModalRef = this.modalService.show(ModalAlertaComponent);
    //console.log('MENSAGEM SERVICE');
    //console.log(tipo);
    //console.log(mensagem);
    //console.log(detalhes);
    bsModalRef.content.tipo = tipo;
    bsModalRef.content.mensagem = mensagem;
    bsModalRef.content.detalhes = detalhes;
    //console.log('MENSAGEM SERVICE - bsModalRef.content');
    //console.log(bsModalRef.content);
  }

  mostrarAlertaPerigo(mensagem: string, detalhes: any) {
    this.mostrarAlerta(mensagem, TipoAlerta.PERIGO, detalhes);
  }

  mostrarSilencioso(mensagem: string, detalhes: any) {
    //console.log(mensagem);
    //console.log(detalhes);
  }

  mostrarServidorInativo(linkDestino: string) {
    const bsModalRef: BsModalRef = this.modalService.show(ModalAlertaComponent);
    bsModalRef.content.servidorInativo = linkDestino;
  }

  mostrarAlertaSucesso(mensagem: string, detalhes: any) {
    this.mostrarAlerta(mensagem, TipoAlerta.SUCESSO, detalhes);
  }

  mostrarAlertaAtencao(mensagem: string, detalhes: any) {
    this.mostrarAlerta(mensagem, TipoAlerta.AVISO, detalhes);
  }

  mostrarAlertaInfo(mensagem: string, detalhes: any) {
    this.mostrarAlerta(mensagem, TipoAlerta.INFO, detalhes);
  }
}
